module.exports = __webpack_public_path__ + "img/whitebox.56a424d1.png";